export const reportHeadText = {
  exportText: 'Export',
  pageTitle: 'Reporting Achievement',
  syncText: 'Last Sync',
};

export const reportTabText = {
  achievementBrandText: 'Brand',
  achievementHostText: 'Host',
  achievementAccountPlatformText: 'Account Platform',
  sessionText: 'Session',
};

export const reportFilterText = {
  searchPlaceholder: 'Cari...',
  brandPlaceholder: 'Pilih Brand',
  platformPlaceholder: 'Pilih Platform',
  accountPlaceholder: 'Pilih Account',
  accountTypePlaceholder: 'Pilih Tipe Account',
  yearMonthPlaceholder: 'Pilih bulan',
  datePlaceholder: 'Pilih tanggal',
};

export const reportExportText = {
  loadingTitle: 'Loading',
  loadingDescription: 'Sedang mendownload file',
  modalContentTitle: 'File berhasil diekspor',
  modalOtherContentText: 'File tidak muncul? ',
  modalOtherContentLinkText: 'download ulang file',
  errorTitle: 'Gagal mengekspor file',
  errorDescription: 'Terjadi kesalahan saat mengekspor data. Silakan periksa kembali file kamu dan coba lagi.',
};

export const reportColumnTargetText = {
  targetLabel: 'dari target',
};
